import React from 'react'
import { RiMenuAddFill } from "react-icons/ri";
import { GoSearch } from "react-icons/go";
import { Saclayout } from '../../../components/SAC Layout/Saclayout';
import Bulkexport from '../../../components/Bulkexport/Bulkexport';
import { AiOutlineDelete } from "react-icons/ai";
import Pagenation from '../../../components/Pagenation/Pagenation';



export default function ServiceSACMgt() {
  
  
  return (
    <div className='p-5'>
      <div className='border-2 w-[100%] rounded-lg shadow-md '>
        <div className='border-b-2 p-4 text-gray-400 text-xl  font-semibold'>
          <h1>SAC Managements</h1>
        </div>

        <div className='flex justify-center gap-2 font-semibold mt-5  '>
          <h1 className='text-red-600 text-xl font-semibold'>ZeroMiddleMan</h1>
          <h1 className='text-xl'>SAC Codes</h1>
        </div>

        <div className='flex justify-center mt-7 gap-4 text-gray-400'>
          <div className='flex'>
            <h1><RiMenuAddFill className='text-xl' /></h1>
            <h1 > this is Add HSN </h1>
          </div>

          <div className='flex'>
            <h1><AiOutlineDelete className='text-xl h-full' /></h1>
            <h1>this is Delete HSN </h1>
          </div>
        </div>

        <div className="border-2 w-[65%] ms-48 p-4 rounded-lg shadow-md border-b mt-4  ">
          <div className='flex gap-2  border-b-2  w-[100%] pb-2 '>
            <div className="border border-gray-500 flex justify-end rounded-full  w-[62%] h-10 ">
              <button className="bg-red-600  text-white px-6 py-2 gap-3 flex rounded-full hover:bg-red-600"><h1><GoSearch className='text-lg mt-1' /></h1>
                Search
              </button>
            </div>
            <div>
              <div className='text-blue-600 border border-blue-600 rounded-lg px-6 py-1.5 ms-6 mt-0.5   '>clear </div>
            </div>

            <div className='ms-10 mt-0.5'>
             <Bulkexport/>
            </div>
          </div>
          
          {/* Open dropdown ..----------- */}
          <div className=''>
            <Saclayout/>
          </div>
        </div>
        <div className='ms-48 mb-6 mt-3'>
          <Pagenation/>
        </div>
      </div>
    </div>
  )
}
